<template lang="pug">
  #section3s1
    .container-fluid
      .row.content-s1.d-flex
        .col-md-5
          img.covid(src="/assets/img/microsite/Mapa_11estados.png")
        .col-11.col-md-7.text.pr-4.d-flex.pl-0
          p.sub-title.neutral-text.mb-0.light 
            span.smaller Dimensionando la tragedia:
          p.sub-title.accent-orange-text.mb-0.bold el exceso de mortalidad
          p.sub-title.neutral-text.bold en 11 estados del país
          p.subtext Recientemente la Secretaría de Salud reconoció que en 2020, en 20 estados del país, hay un exceso de mortalidad de 55% comparando con el año pasado. ¿Qué sabemos sobre cómo se distribuye este exceso de mortalidad entre los distintos estados del país? En Data Cívica hicimos un cálculo de exceso de mortalidad para 11 estados con el objetivo de entender el tamaño de la tragedia.
          router-link.story-btn(to="/el-exceso-de-mortalidad#chapter6") Leer Blog

</template>

<script>

export default {
  name: "Section2s1"
};
</script>

<style lang="scss">
#section3s1 {
  min-height: 100vh;
  padding: 1rem 0;
  margin-top: 5rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 300px;
    }
  }
  .content-s1 {
    min-height: 85vh;
    background-image: url("/assets/img/microsite/desktop_back.png");
    background-size: 100% 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    .covid {
      margin: 0;
      width: 100%;
      max-width: 650px;
      text-align: center;
    }
    .text {
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .subtext {
        line-height: 1.75;
        color: #f7b3aa;
      }
      a {
        color: #fff;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #ff6561;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 3.5rem;
        margin: 2rem auto;
      }
      .story-btn:hover {
        background-color: #ff6561;
      }
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #section3s1 {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
    .sub-title {
      font-size: 1.7rem;;
    }
    .content-s1 {
      min-height: 0;
      background-image: url("/assets/img/microsite/mobile_back.png");
      padding: 2rem 0;
      .covid {
        width: 80vw;
        max-width: 460px;
        margin-bottom: 1rem;
      }
      .text {
        .subtext {
          font-size: 0.8rem;
          line-height: 1.5;
          max-width: 90%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          border-radius: 35px;
          font-size: 1rem;
          padding: 0.5rem 2.5rem;
          margin: 1rem auto 2rem auto;
        }
      }
    }
  }
}
</style>
